import { Fragment } from 'react';

import { H3Section } from 'bloko/blocks/header';
import Icon, { IconColor, IconScale, IconView } from 'bloko/blocks/icon';
import VSpacing from 'bloko/blocks/vSpacing';

import useTrls from 'hooks/translation/useTrls';

import Table from 'components/Table';

import AddOwnerForm from 'components/Admin/CrmActivity/Owners/AddOwnerForm';
import deleteOwner from 'components/Admin/CrmActivity/Owners/deleteOwner';
import TableBody from 'components/Table/TableBody';
import TableCell, { TableCellKind } from 'components/Table/TableCell';
import TableHead from 'components/Table/TableHead';
import TableHeadCell from 'components/Table/TableHeadCell';
import TableRow from 'components/Table/TableRow';

import { useDispatch, useSelector } from 'store/utils';

import 'components/Admin/CrmActivity/Owners/Owners.less';

const Owners = () => {
    const dispatch = useDispatch();
    const { owners } = useSelector((state) => state.crmActivity);
    const trl = useTrls();

    return (
        <Fragment>
            <H3Section lite>{trl('Admin.CrmActivity.Users.title')}</H3Section>
            <VSpacing base={3} />
            <Table withStripes bordered fullWidth>
                <TableHead>
                    <TableRow>
                        <TableHeadCell>{trl('Admin.CrmActivity.Users.Header.name')}</TableHeadCell>
                        <TableHeadCell>{trl('Admin.CrmActivity.Users.Header.email')}</TableHeadCell>
                        <TableHeadCell>{trl('Admin.CrmActivity.Users.Header.action')}</TableHeadCell>
                    </TableRow>
                </TableHead>
                <TableBody>
                    {owners.map(({ id, name, email }) => (
                        <TableRow key={id}>
                            <TableCell>{name}</TableCell>
                            <TableCell>{email}</TableCell>
                            <TableCell kind={TableCellKind.Title}>
                                <span
                                    className="crm-activity-user-delete"
                                    onClick={() => dispatch(deleteOwner(parseInt(id, 10)))}
                                >
                                    <Icon
                                        view={IconView.Cross}
                                        initial={IconColor.SpecialRedBranded}
                                        scale={IconScale.Medium}
                                    />
                                </span>
                            </TableCell>
                        </TableRow>
                    ))}
                </TableBody>
            </Table>
            <AddOwnerForm />
        </Fragment>
    );
};

export default Owners;
